export const icon = {
  margin: 20,
  size: 100
};

export const device = {
  width: 368,
  height: 448
};
